// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { darken, Fade, IconButton, Slide, styled } from '@mui/material';

interface CollapseButtonProps {
  left: number;
  top: number;
  sz: number; // in pixels
}

const CollapseButton = styled(IconButton)<CollapseButtonProps>(({ left, top, sz, theme }) => ({
  position: 'absolute',
  left,
  top,
  zIndex: 10,
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.default,
  ml: 'auto',
  mt: 1,
  mb: 1,
  width: `${sz}px`,
  height: `${sz}px`,
  border: `1px solid ${theme.palette.primary.main}`,
  '& :hover': {
    backgroundColor: darken(theme.palette.background.default, 0.025),
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '100%',
  },
}));

export const Collapser: React.FC<{ open?: boolean; toggleOpen: () => void }> = ({
  open,
  toggleOpen,
}) => {
  const iconSize = 24;
  const halfIcon = iconSize / 2;

  const drawerOpenWidth = 240;
  const drawerClosedWidth = 64;

  const leftPos = open ? drawerOpenWidth - halfIcon : drawerClosedWidth - halfIcon;
  const topPos = 64 + halfIcon;

  return (
    <>
      {open && (
        <Slide in={open} direction="right">
          <CollapseButton left={leftPos} top={topPos} sz={iconSize} onClick={toggleOpen}>
            <ChevronLeftIcon />
          </CollapseButton>
        </Slide>
      )}

      {!open && (
        <Fade in={!open}>
          <CollapseButton left={leftPos} top={topPos} sz={iconSize} onClick={toggleOpen}>
            <ChevronRightIcon />
          </CollapseButton>
        </Fade>
      )}
    </>
  );
};
